import { mainButton } from '@telegram-apps/sdk-react';
import { useEffect, useRef } from 'react';
import { runtime } from '@/lib/runtime';
import { brandMainButtonColors } from '@/lib/theme';

/** Telegram'ning MainButton'i mavjudmi (dev mock'da yo'q — sahifa oddiy tugma chizadi). */
export const hasNativeMainButton = () => !runtime.mocked && mainButton.mount.isAvailable();

/**
 * Telegram MainButton'ni sahifaga bog'laydi (SPEC §11). Sahifadan chiqqanda yashiriladi.
 * Native bo'lmasa hech narsa qilmaydi — `<MainAction>` komponenti o'zi fallback chizadi.
 */
export function useMainButton(
  text: string,
  onClick: () => void,
  { enabled = true, loading = false, visible = true } = {},
) {
  const handler = useRef(onClick);
  useEffect(() => {
    handler.current = onClick;
  });

  useEffect(() => {
    if (!hasNativeMainButton()) return;
    if (!mainButton.isMounted()) mainButton.mount();
    const off = mainButton.onClick(() => handler.current());
    return () => {
      off();
      mainButton.setParams({ isVisible: false, isLoaderVisible: false });
    };
  }, []);

  useEffect(() => {
    if (!hasNativeMainButton()) return;
    mainButton.setParams({
      ...brandMainButtonColors(),
      text,
      isVisible: visible,
      isEnabled: enabled && !loading,
      isLoaderVisible: loading,
    });
  }, [text, enabled, loading, visible]);
}
